import { render, staticRenderFns } from "./GeneralPage.vue?vue&type=template&id=324818e9&"
import script from "./GeneralPage.vue?vue&type=script&lang=js&"
export * from "./GeneralPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports